<template>
  <div class="search-section">
    <div class="divider">
      <h4>بحث في ارصدة العملاء والخزن</h4>
      <hr
        role="separator"
        aria-orientation="horizontal"
        class="v-divider theme--dark"
      />
    </div>
    <div class="row">
      <div class="col-lg-3 py-0">
        <div class="input_wrapper top_label auto_complete">
          <label class="form-label"> إسم العميل</label>
          <v-autocomplete
            v-model="searchData.username"
            :search-input.sync="searchOptions.search_users"
            @change="$emit('filterTable', { ...searchData, focus: 'client' })"
            :items="users"
            item-text="name"
            item-value="name"
            :hide-no-data="!users"
            dense
          ></v-autocomplete>
          <button class="button_style_1 load_inline" v-if="load_users">
            <span class="btn_loader"></span>
          </button>
        </div>
      </div>

      <div class="col-lg-3 py-0">
        <div class="input_wrapper top_label mb-3">
          <label class="form-label"> الخزنة </label>
          <multiselect
            v-model="searchData.lock"
            :options="searchOptions.locks"
            label="name"
            track-by="name"
            placeholder=" "
            :searchable="true"
            :allow-empty="true"
            :show-labels="false"
            @input="
              chooseLock(searchData.lock),
                $emit('filterTable', { ...searchData, focus: 'wallet' })
            "
          >
          </multiselect>
        </div>
      </div>

      <div class="col-lg-3 py-0">
        <div class="input_wrapper top_label mb-3">
          <label class="form-label"> البنك </label>
          <multiselect
            v-model="searchData.bank"
            :options="searchOptions.banks"
            label="name"
            track-by="name"
            @input="
              chooseItem(searchData.bank),
                $emit('filterTable', { ...searchData, focus: 'dubai' })
            "
            placeholder=" "
            :searchable="true"
            :allow-empty="true"
            :show-labels="false"
          >
          </multiselect>
        </div>
      </div>

      <div class="col-lg-3 py-0">
        <div class="input_wrapper top_label auto_complete">
          <label class="form-label"> إسم المؤسسة</label>
          <v-autocomplete
            v-model="searchData.enterprice"
            :search-input.sync="searchOptions.search_enterprices"
            :items="enterprices"
            @change="$emit('filterTable', { ...searchData, focus: 'account' })"
            item-text="name_ar"
            item-value="name"
            :hide-no-data="!enterprices"
            dense
          ></v-autocomplete>
          <button class="button_style_1 load_inline" v-if="load_enterprices">
            <span class="btn_loader"></span>
          </button>
        </div>
      </div>

      <!-- <div class="col-lg-12 text-center py-0">
        <button
          class="button_style_1"
          @click="$emit('filterTable', { ...searchData, focus: null })"
        >
          بحث
        </button>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      load_users: false,
      load_enterprices: false,
      // search
      searchData: {
        client: null,
        wallet: null,
        enterprice: null,
        username: null,
        lock: null,
        lockId: null,
        bank: null,
        bankId: null,
      },
      searchOptions: {
        banks: [],
        search_users: "",
        locks: [],
        search_enterprices: "",
      },
      users: null,
      enterprices: null,
    };
  },
  watch: {
    [`searchOptions.search_users`](newVal, oldVal) {
      if (!newVal || newVal.length < 3) {
        this.users = null;
      } else {
        if (!newVal & (oldVal == "")) {
          this.get_filterd_users(oldVal);
        } else if ((newVal == "") & (oldVal != "")) {
          this.get_filterd_users(newVal);
        } else {
          this.get_filterd_users(newVal);
        }
      }
    },

    [`searchOptions.search_enterprices`](newVal, oldVal) {
      if (!newVal || newVal.length < 3) {
        this.enterprices = null;
      } else {
        if (!newVal & (oldVal == "")) {
          this.get_filterd_enterprices(oldVal);
        } else if ((newVal == "") & (oldVal != "")) {
          this.get_filterd_enterprices(newVal);
        } else {
          this.get_filterd_enterprices(newVal);
        }
      }
    },
  },
  methods: {
    // get_filterd_users
    get_filterd_users(keyword) {
      this.load_users = true;
      this.$axios({
        method: "GET",
        url: `client/customer/search?keyword=${keyword}`,
      })
        .then((res) => {
          this.users = res.data.data;
          this.load_users = false;
        })
        .catch((err) => {
          this.load_users = false;
        });
    },
    // get_filterd_enterprices
    get_filterd_enterprices(keyword) {
      this.load_enterprices = true;
      this.$axios({
        method: "GET",
        url: `help/enterprises?keyword=${keyword}`,
      })
        .then((res) => {
          this.enterprices = res.data.data;
          this.load_enterprices = false;
        })
        .catch((err) => {
          this.load_enterprices = false;
        });
    },
    getBanks() {
      // START:: GET BANKS
      this.$axios({
        method: "GET",
        url: `client/bank`,
      })
        .then((res) => {
          this.searchOptions.banks = res.data.data;
        })
        .catch((err) => {
          console.log(err.response.data);
        });
      // END:: GET BANKS
    },
    getSafes() {
      // START:: GET SAFES
      this.$axios({
        method: "GET",
        url: `client/wallet`,
      })
        .then((res) => {
          this.searchOptions.locks = res.data.data;
        })
        .catch((err) => {
          console.log(err.response.data);
        });
      // END:: GET SAFES
    },
    chooseItem(item) {
      if (this.searchData.bank) {
        this.searchData.bankId = item.id;
      } else {
        this.searchData.bankId = null;
      }
    },
    chooseLock(item) {
      if (this.searchData.lock) {
        this.searchData.lockId = item.id;
      } else {
        this.searchData.lockId = null;
      }
    },
  },
  created() {
    this.getBanks();
    this.getSafes();
  },
};
</script>

<style lang="scss">
.search-section .load_inline {
  width: 30px !important;
  height: 25px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 0 !important;
  left: 1px;
  position: absolute !important;
  background: transparent !important;
  margin: 0 !important;

  span {
    right: 0 !important;
    left: 0 !important;
    margin: auto !important;
    border-top: 3px solid var(--mainColor-2) !important;
    border-right: 3px solid transparent !important;
  }
}
</style>
